/* eslint-disable no-unused-vars */
import React, { useContext } from 'react';
import { CotizadorContext } from '../context';
import useDistanceData from './useDistanceData';
import { getTotalFromSimulation, runSimulation } from '../components/utils/creditSimulation';

const useTimeData = () => {
    const [state, setState] = useContext(CotizadorContext);
    const { distance_options: original_distance_options } = useDistanceData();

    const setSelectedTime = async selected_time => {
        let simulation = null;

        if (state.selected_car) {
            document.getElementById('cotizador_overlay').style.display = 'block';
            const simulationResult = await runSimulation(state.selected_car, selected_time, state.selected_distance, state.downpayment_percentage);
            
            if (!simulationResult.success) {
                console.error('[useTimeData] Error en simulación:', simulationResult.error);
                // Mostrar error al usuario con notificación pero PERMITIR el cambio de tiempo
                setState(prevState => {
                    // copy current distance options and enable all
                    const distance_options = [...original_distance_options]
                    distance_options[0].enabled = true;
                    distance_options[1].enabled = true;
                    distance_options[2].enabled = true;

                    return {
                        ...prevState,
                        selected_time,
                        distance_options,
                        error_notification: simulationResult.error,
                        simulation_results: null,
                        simulation_total: 0
                    }
                });
                document.getElementById('cotizador_overlay').style.display = 'none';
                return;
            }
            
            simulation = simulationResult.data;
            
            setState(prevState => {
                // copy current distance options and enable all
                const distance_options = [...original_distance_options]
                distance_options[0].enabled = true;
                distance_options[1].enabled = true;
                distance_options[2].enabled = true;

                const newState = {
                    ...prevState,
                    selected_time,
                    distance_options,
                    simulation_results: simulation,
                    simulation_total: getTotalFromSimulation(simulation),
                    simulation_error: null
                };
                
                return newState;
            })
        } else {
            setState(prevState => {

                // copy current distance options and enable all
                const distance_options = [...original_distance_options]
                distance_options[0].enabled = true;
                distance_options[1].enabled = true;
                distance_options[2].enabled = true;

                return {
                    ...prevState,
                    selected_time,
                    distance_options,
                }
            })
        }

        document.getElementById('cotizador_overlay').style.display = 'none';
    }

    const getSelectedTime = () => state.selected_time

    return {
        time_options: state.time_options,
        getSelectedTime,
        setSelectedTime,
    };
}

export default useTimeData;